








































































































































































































































































































































































































































































































import Vue from "vue";
import { mapActions } from "vuex";
export default Vue.extend({
	methods: {
		...mapActions(["setFilter"]),
		select(value: string) {
			this.setFilter({
				filter: ["Subcellular_localization", "=", value]
			});
		}
	}
});
